// @generated by TypeGen from LogbookApp/CurrentLogApi.swift - DO NOT EDIT

import type { IAccountSubscriptionStatus } from "../LogbookModel/Account"
import type { ICruisesResponse } from "../LogbookModel/Cruise"
import type { ICurrentInfo } from "../LogbookModel/Current"
import type { IDaysResponse } from "../LogbookModel/Day"
import type { ILogLighting } from "../LogbookModel/Lighting"
import type { ILog, ILogResponse, ILogsResponse } from "../LogbookModel/Log"
import type { ILogStopType } from "../LogbookModel/Log/LogMetadata"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { IStatus } from "../LogbookModel/Status"
import type { IMonitorStatusType } from "../LogbookModel/Status/MonitorStatus"
import type { IShipStatus } from "../LogbookModel/Status/ShipStatus"
import type { ITripsResponse } from "../LogbookModel/Trip"
import type { IEngineHintRequest } from "./EngineMissingApi"
import type { IAppResponse } from "./Routes"

export interface ISailChange {
  sail: string;
  on: boolean;
}

export interface ICancelProvisionalRequest {
  key: string;
}

export interface IEngineStatusRequest {
  engine: string;
  on: boolean;
}

export interface ILightingStatusRequest {
  lighting: ILogLighting;
}

export interface ILogRequest {
  monitorEnabled?: boolean;
  monitorType?: IMonitorStatusType;
  status?: number;
}

export interface ISailChangeRequest {
  sails: ISailChange[];
}

export interface IStopRequest {
  endLocation?: string;
  shipStatus: IShipStatus;
  statusId?: number;
  stopEngines?: boolean;
  stopType: ILogStopType;
}

export interface ICurrentDayResponse {
  cruises: ICruisesResponse;
  currentLog?: ILog;
  day: number;
  firstDay: number;
  days?: IDaysResponse;
  logs?: ILogsResponse;
  provisionalLogs?: ILog[];
  status?: IStatus[];
  subscriptionStatus?: IAccountSubscriptionStatus;
  trips?: ITripsResponse;
}

export enum ICreateStatus {
  allowed = "allowed",
  deniedInMotion = "deniedInMotion",
  deniedBlankExists = "deniedBlankExists",
}

export interface CurrentLogApiAppEndpoints {
  "GET /api/ship/current": {
    params: {};
    query: {};
    request: never;
    response: ICurrentInfo;
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ship/current/day": {
    params: {};
    query: {};
    request: never;
    response: ICurrentDayResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/engine": {
    params: {};
    query: {};
    request: IEngineStatusRequest;
    response: ILogResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/engineHint": {
    params: {};
    query: {};
    request: IEngineHintRequest;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/lighting": {
    params: {};
    query: {};
    request: ILightingStatusRequest;
    response: ILogResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/log": {
    params: {};
    query: {};
    request: ILogRequest;
    response: ILogResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/provisional/cancel": {
    params: {};
    query: {};
    request: ICancelProvisionalRequest;
    response: IAppResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/sails": {
    params: {};
    query: {};
    request: ISailChangeRequest;
    response: ILogResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/stop": {
    params: {};
    query: {};
    request: IStopRequest;
    response: ILogResponse;
    permission: { ship: IShipUserLevel };
  };
}

export const currentLogApiAppEndpoints = {
  "GET /api/ship/current": { permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ship/current/day": { permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/current/engine": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/engineHint": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/lighting": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/log": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/provisional/cancel": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/sails": { permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/stop": { permission: { ship: IShipUserLevel.editCurrent } },
} as const;
